var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _line, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _g, _path61, _g2, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _ellipse, _ellipse2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHelloSupervisor = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 1543,
  height: 1276,
  viewBox: "0 0 1543 1276",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1270.24 299.894H313.044C297.127 299.894 284.274 313.494 284.274 330.319V383.052V987.569C284.274 1004.34 297.18 1017.99 313.044 1017.99H1270.24C1286.16 1017.99 1299.01 1004.39 1299.01 987.569V382.998V330.265C1299.01 313.494 1286.11 299.894 1270.24 299.894Z",
  fill: "white"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M1270.24 299.894H313.044C297.127 299.894 284.274 313.494 284.274 330.319V383.052V987.569C284.274 1004.34 297.18 1017.99 313.044 1017.99H1270.24C1286.16 1017.99 1299.01 1004.39 1299.01 987.569V382.998V330.265C1299.01 313.494 1286.11 299.894 1270.24 299.894Z",
  stroke: "#243045",
  strokeWidth: 4.0553,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M1270.78 406.648H315.787V930.481H1270.78V406.648Z",
  fill: "white"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M1256.15 441.052H1004.92V536.949H1256.15V441.052Z",
  fill: "#F4F5F7"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M1256 441H1005V598H1256V441Z",
  fill: "#F4F5F7"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M1256.15 668.593H1004.92V728.797H1256.15V668.593Z",
  fill: "#F4F5F7"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M981.846 437.828H338.104V597.961H981.846V437.828Z",
  fill: "#F4F5F7"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M981.846 618.656H338.104V778.789H981.846V618.656Z",
  fill: "#F4F5F7"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M981.846 798.893H338.104V905.81H981.846V798.893Z",
  fill: "#F4F5F7"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  d: "M793.256 356.443C799.79 356.443 805.087 351.148 805.087 344.617C805.087 338.086 799.79 332.791 793.256 332.791C786.722 332.791 781.426 338.086 781.426 344.617C781.426 351.148 786.722 356.443 793.256 356.443Z",
  fill: "#231F20"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  d: "M1472.22 1009.02H293.577V1041H1472.22V1009.02Z",
  fill: "#243045"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M1270.73 371.87H314.12V409.014H1270.73V371.87Z",
  fill: "#DFE1E6"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M1237.28 397.835C1241.38 397.835 1244.7 394.514 1244.7 390.417C1244.7 386.32 1241.38 382.999 1237.28 382.999C1233.18 382.999 1229.86 386.32 1229.86 390.417C1229.86 394.514 1233.18 397.835 1237.28 397.835Z",
  fill: "white"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M1213.03 397.835C1217.12 397.835 1220.45 394.514 1220.45 390.417C1220.45 386.32 1217.12 382.999 1213.03 382.999C1208.93 382.999 1205.6 386.32 1205.6 390.417C1205.6 394.514 1208.93 397.835 1213.03 397.835Z",
  fill: "white"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M1188.77 397.835C1192.87 397.835 1196.19 394.514 1196.19 390.417C1196.19 386.32 1192.87 382.999 1188.77 382.999C1184.67 382.999 1181.35 386.32 1181.35 390.417C1181.35 394.514 1184.67 397.835 1188.77 397.835Z",
  fill: "white"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "M641.5 602.5C662.849 587.986 692.443 589.144 707.5 573.824C758.5 597 790.165 555.951 822 523C860.073 483.598 856.549 400.79 892.471 359.399C905.108 344.832 921.617 334.189 935.33 320.643C954.743 301.399 968.294 276.296 973.618 249.472C979.049 222.219 976.629 192.278 991.471 168.788C1004.27 148.522 1027.66 137.073 1041.7 117.668C1065.73 84.5013 1058.15 36.9828 1075.74 0H120.152C117.409 1.07508 115.796 0.645048 113.054 1.72013C111.978 31.9836 122.357 62.5159 141.608 85.8989C155.966 103.369 175.003 116.861 187.371 135.783C203.45 160.348 206.407 191.042 217.431 218.241C226.68 241.087 241.845 261.567 260.989 277.102C271.905 285.971 284.22 293.389 292.878 304.463C308.473 324.459 309.064 351.874 315.356 376.439C322.562 404.606 338.264 430.516 359.882 450.029C378.757 467.069 402.418 479.701 415.754 501.364C429.682 523.994 430.488 553.828 448.019 573.824C469.314 598.067 507.871 599.465 531.478 621.558C547.342 636.394 594.825 648.058 616.712 643.758C627.144 641.715 631.39 609.38 641.5 602.5Z",
  fill: "white"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M449 843.008C468.838 849.816 492.9 853.476 506.734 850.758C512.292 849.67 516.094 839.984 519.962 830.13C523.355 821.488 526.799 812.715 531.522 809.5C541.477 802.732 553.225 799.372 564.456 796.16C577.31 792.483 589.487 789 597.522 780.824C643.981 801.936 674.395 769.752 703.509 738.943C706.355 735.932 709.188 732.934 712.022 730C731.551 709.79 740.136 678.159 748.713 646.556C756.858 616.546 764.997 586.559 782.493 566.399C789.79 557.988 798.378 550.885 806.973 543.776C813.263 538.573 819.557 533.367 825.352 527.643C844.765 508.399 858.316 483.296 863.64 456.472C865.334 447.971 866.265 439.208 867.193 430.46C869.241 411.167 871.281 391.95 881.493 375.788C888.255 365.081 897.974 356.835 907.708 348.576C916.398 341.203 925.099 333.82 931.719 324.668C945.134 306.158 948.701 283.178 952.29 260.055C955.132 241.744 957.988 223.343 965.759 207H449V843.008Z",
  fill: "white"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  d: "M740.664 262.642C780.58 262.642 812.938 230.297 812.938 190.397C812.938 150.497 780.58 118.151 740.664 118.151C700.749 118.151 668.391 150.497 668.391 190.397C668.391 230.297 700.749 262.642 740.664 262.642Z",
  stroke: "#CFD1DA",
  strokeWidth: 3.1766,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  d: "M740.665 118.151V262.641",
  stroke: "#CFD1DA",
  strokeWidth: 3.1766,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  d: "M668.391 190.396H812.938",
  stroke: "#CFD1DA",
  strokeWidth: 3.1766,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  d: "M692.159 136.856H708.991H719.262H731.2H740.664H749.699H761.637H771.908H789.17",
  stroke: "#CFD1DA",
  strokeWidth: 3.1766,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  d: "M673.499 217.166H689.148H705.011H722.972H740.664H757.926H775.833H791.751H807.829",
  stroke: "#CFD1DA",
  strokeWidth: 3.1766,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  d: "M692.105 243.936H710.819H720.284H731.2H740.664H749.699H760.615H770.079H789.223",
  stroke: "#CFD1DA",
  strokeWidth: 3.1766,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  d: "M673.499 163.626H688.233H704.366H722.918H740.664H757.926H776.532H792.665H807.829",
  stroke: "#CFD1DA",
  strokeWidth: 3.1766,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  d: "M740.665 118.151C792.504 152.177 795.623 222.702 740.665 262.695",
  stroke: "#CFD1DA",
  strokeWidth: 3.1766,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  d: "M740.234 118.151C688.395 152.177 685.276 222.702 740.234 262.695",
  stroke: "#CFD1DA",
  strokeWidth: 3.1766,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  d: "M298.633 81.814H256.849C249.267 81.814 243.137 87.9419 243.137 95.5212V114.174C243.137 121.753 249.267 127.881 256.849 127.881H280.134L289.276 148.738L297.127 127.881H298.633C306.215 127.881 312.345 121.753 312.345 114.174V95.5212C312.399 87.9419 306.215 81.814 298.633 81.814Z",
  stroke: "#CFD1DA",
  strokeWidth: 3.1766,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  d: "M523.231 131H496.653C487.998 131 481 123.95 481 115.23V78.7701C481 70.0502 487.998 63 496.653 63H544.347C553.002 63 560.061 70.0502 560 78.7701V115.23C560 123.95 553.002 131 544.347 131H542.628",
  stroke: "#CFD1DA",
  strokeWidth: 3.1766,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  d: "M699.074 371H678.888C672.315 371 667 365.609 667 358.94V331.06C667 324.391 672.315 319 678.888 319H715.112C721.685 319 727.046 324.391 727 331.06V358.94C727 365.609 721.685 371 715.112 371H713.806",
  stroke: "#CFD1DA",
  strokeWidth: 3.1766,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  d: "M290.297 117.451H264.7C264.7 110.947 269.97 105.679 276.477 105.679H278.574C285.027 105.679 290.297 110.947 290.297 117.451Z",
  stroke: "#CFD1DA",
  strokeWidth: 3.1766,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  d: "M277.499 103.314C280.647 103.314 283.199 100.763 283.199 97.6159C283.199 94.469 280.647 91.918 277.499 91.918C274.351 91.918 271.799 94.469 271.799 97.6159C271.799 100.763 274.351 103.314 277.499 103.314Z",
  stroke: "#CFD1DA",
  strokeWidth: 3.1766,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  d: "M615.906 223.617C619.945 223.617 623.22 220.344 623.22 216.307C623.22 212.269 619.945 208.996 615.906 208.996C611.867 208.996 608.593 212.269 608.593 216.307C608.593 220.344 611.867 223.617 615.906 223.617Z",
  stroke: "#CFD1DA",
  strokeWidth: 3.1766,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  d: "M922.313 100.621C926.353 100.621 929.627 97.348 929.627 93.3105C929.627 89.273 926.353 86 922.313 86C918.274 86 915 89.273 915 93.3105C915 97.348 918.274 100.621 922.313 100.621Z",
  stroke: "#CFD1DA",
  strokeWidth: 3.1766,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  d: "M712.313 423.621C716.353 423.621 719.627 420.348 719.627 416.311C719.627 412.273 716.353 409 712.313 409C708.274 409 705 412.273 705 416.311C705 420.348 708.274 423.621 712.313 423.621Z",
  stroke: "#CFD1DA",
  strokeWidth: 3.1766,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  d: "M380.21 163.358C384.249 163.358 387.523 160.085 387.523 156.048C387.523 152.01 384.249 148.737 380.21 148.737C376.171 148.737 372.896 152.01 372.896 156.048C372.896 160.085 376.171 163.358 380.21 163.358Z",
  stroke: "#CFD1DA",
  strokeWidth: 3.1766,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  d: "M656.398 92.7786C664.465 91.5422 667.369 84.0704 668.175 73.8572C669.681 83.4791 672.208 91.166 680.382 92.7786C673.338 95.7888 669.197 101.379 668.175 109.872C667.906 101.702 663.604 96.2726 656.398 92.7786Z",
  fill: "#F7B548"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  d: "M879.351 199.374C883.169 198.782 884.567 195.235 884.943 190.397C885.696 194.966 886.879 198.621 890.751 199.374C887.417 200.825 885.427 203.459 884.943 207.491C884.782 203.62 882.738 201.04 879.351 199.374Z",
  fill: "#F7B548"
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  d: "M176.725 51.2279C180.543 50.6366 181.941 47.0888 182.317 42.251C183.07 46.8201 184.253 50.4753 188.125 51.2279C184.791 52.6793 182.801 55.3132 182.317 59.3448C182.156 55.4745 180.112 52.8943 176.725 51.2279Z",
  fill: "#F7B548"
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  d: "M391.664 58.0533C395.482 57.462 396.88 53.9143 397.257 49.0764C398.01 53.6455 399.193 57.3008 403.064 58.0533C399.73 59.5047 397.741 62.1386 397.257 66.1702C397.149 62.2999 395.106 59.666 391.664 58.0533Z",
  fill: "#F7B548"
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  d: "M802.129 68.3754C805.947 67.7841 807.345 64.2363 807.722 59.3984C808.474 63.9675 809.657 67.6228 813.529 68.3754C810.195 69.8267 808.206 72.4607 807.722 76.4922C807.56 72.6219 805.571 70.0417 802.129 68.3754Z",
  fill: "#F7B548"
})), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  d: "M605 341.977C608.818 341.386 610.216 337.838 610.593 333C611.346 337.569 612.529 341.224 616.4 341.977C613.066 343.428 611.077 346.062 610.593 350.094C610.431 346.223 608.442 343.643 605 341.977Z",
  fill: "#F7B548"
})), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
  d: "M650 720.977C653.818 720.386 655.216 716.838 655.593 712C656.346 716.569 657.529 720.224 661.4 720.977C658.066 722.428 656.077 725.062 655.593 729.094C655.431 725.223 653.442 722.643 650 720.977Z",
  fill: "#F7B548"
})), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
  d: "M425.459 524.73L402.873 530.052",
  stroke: "#231F20",
  strokeWidth: 3.1766,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
  d: "M1256 658.56V892.44C1256 899.914 1252.28 906 1247.67 906H1008.33C1003.72 906 1000 899.958 1000 892.44V658.56C1000 651.086 1003.72 645 1008.33 645H1247.7C1252.28 645 1256 651.086 1256 658.56Z",
  fill: "#F4F5F7"
})), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
  d: "M1256 629.123V648H1000V629.123C1000 623.544 1003.72 619 1008.33 619H1247.7C1252.28 619 1256 623.544 1256 629.123Z",
  fill: "#F4F5F7"
})), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
  d: "M517.611 105.75V104.25H516.111H506.574L520.5 90.368L534.426 104.25H524.889H523.389V105.75V130.5H517.611V105.75Z",
  stroke: "#CFD1DA",
  strokeWidth: 3
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 683,
  y1: 332,
  x2: 712,
  y2: 332,
  stroke: "#CFD1DA",
  strokeWidth: 2
})), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
  d: "M619.144 961.714L639.205 1015.06C640.685 1018.48 641.702 1022.18 642.071 1025.97C645.492 1056.2 645.122 1090.22 643.735 1125.26C643.643 1126.83 643.181 1128.31 642.071 1129.42C639.298 1132.38 635.322 1130.71 633.473 1128.03C631.994 1125.91 631.624 1123.32 631.162 1120.82C627.834 1099 626.447 1077 625.06 1055C625.615 1076.26 625.523 1096.41 626.077 1117.68C626.17 1122.58 626.17 1127.94 623.211 1131.82C622.564 1132.66 621.732 1133.39 620.715 1133.67C619.236 1134.04 617.757 1133.12 616.925 1131.92C616.093 1130.71 615.723 1129.23 615.446 1127.76C610.638 1105.66 606.848 1083.29 604.167 1060.73C602.78 1083.56 609.806 1106.12 609.251 1128.96C609.251 1130.44 608.604 1131.92 607.402 1132.75C605.091 1134.6 602.595 1132.93 601.116 1130.99C598.989 1128.31 597.972 1124.98 597.048 1121.75C591.316 1102.52 586.416 1083.1 582.441 1063.5C582.718 1079.13 582.256 1093.36 582.533 1108.99C582.625 1112.78 582.625 1116.66 580.684 1119.9C580.314 1120.45 579.852 1121.01 579.297 1121.38C576.339 1123.23 573.473 1119.99 572.179 1117.12C569.128 1110.1 568.388 1102.42 567.833 1094.75C566.724 1079.03 566.354 1063.22 565.984 1047.51C559.143 1014.97 555.445 997.215 555.353 974.287L619.144 961.714Z",
  fill: "#F7A889"
})), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M546.431 1042.29L583.562 969.599L634.001 1042.29L645.001 1114L640.001 1129L632.001 1124L625.501 1074.5L625.501 1109.5L625.501 1133L615.501 1131.5L610.501 1102L605.501 1061.07L604.001 1068.5L607.501 1105.5L609.001 1131.5L598.501 1124L590.501 1098.5L583.562 1065.5L522.123 1043.29L547.695 1058.85L545.838 1061.07L522.123 1043.29L452.001 990.707L546.431 1042.29Z",
  fill: "url(#paint0_linear_240_5)"
})), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
  d: "M497.571 476.163C469.096 497.241 444.412 530.524 467.802 594.315L503.95 784.671C504.043 785.318 504.228 785.873 504.32 786.52C513.288 825.812 552.117 845.134 579.205 816.197L604.999 780.88L571.809 565.84C556.555 500.2 530.391 475.7 497.571 476.163Z",
  fill: "#EBECEF"
})), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
  d: "M591.501 790.588L618.959 961.991L554.983 974.75L502.841 818.693L591.501 790.588Z",
  fill: "#F7A889"
})), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
  d: "M598.527 748.244L634.028 946.274L535.383 965.781L498.865 800.572L598.527 748.244Z",
  fill: "#EBECEF"
})), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
  d: "M550.915 962.546L593.35 954.318L554.983 974.749L550.915 962.546Z",
  fill: "#F7978B"
})), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
  d: "M601.578 976.136C591.593 992.315 595.568 1015.7 610.268 1027.63C610.73 1028 610.083 1037.71 610.175 1039.19C610.268 1044.09 609.991 1048.89 610.36 1053.79C611.008 1063.5 612.672 1073.12 615.353 1082.45C616.185 1085.23 617.294 1088.28 619.975 1089.39C622.749 1090.5 625.985 1088.93 627.649 1086.43C629.313 1083.93 629.775 1080.88 630.052 1077.92C631.532 1063.22 632.826 1049.17 636.247 1034.84L601.578 976.136Z",
  fill: "#F7A889"
})), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
  d: "M287.706 606.518L270.88 476.347C234.917 483.928 210.51 472.372 180.741 574.9L66.749 716.442L71.8338 758.877C73.0357 769.694 77.6582 779.956 85.2392 787.722C107.427 810.65 137.751 798.076 156.981 778.846C166.596 769.232 287.706 606.518 287.706 606.518Z",
  fill: "#EBECEF"
})), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
  d: "M129.061 667.998L100.771 507.226L36.6104 508.89L57.874 661.064L129.061 667.998Z",
  fill: "#F7A889"
})), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
  d: "M159.293 669.385L129.986 529.323L24.3145 536.164L72.2964 763.685L159.293 669.385Z",
  fill: "#EBECEF"
})), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
  d: "M150.232 622.42L170.387 727.166",
  stroke: "#EBECEF",
  strokeWidth: 8,
  strokeMiterlimit: 10
})), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
  d: "M107.982 476.902C108.537 469.136 107.89 461.371 107.335 453.605C106.411 441.771 105.486 429.845 104.562 418.011C104.007 410.892 103.452 403.681 101.418 396.84C100.864 394.991 100.031 392.957 97.9976 392.31C95.9636 391.663 93.6524 392.865 92.4505 394.621C91.2487 396.378 90.9713 398.412 90.6939 400.353C88.8449 414.591 89.3072 429.475 84.2224 443.065C78.3055 458.782 75.2547 475.238 75.532 491.694C75.6245 498.906 76.549 506.579 81.1715 512.311C87.828 520.539 97.7202 521.001 100.771 510.832C104.099 499.645 107.15 488.366 107.982 476.902Z",
  fill: "#F7A889"
})), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
  d: "M90.6942 458.32C88.383 446.394 85.0547 434.375 80.802 423.096C78.6756 417.457 77.8436 411.078 76.3644 405.161C74.7927 398.782 73.1286 392.495 71.2796 386.116C69.4305 379.552 67.3966 372.896 64.1609 366.794C62.6816 364.02 60.5553 361.154 57.5044 360.969C56.2101 360.877 54.9158 361.432 54.2686 362.449C53.8064 363.281 53.8064 364.298 53.8064 365.222C53.9913 385.746 60.0006 401.093 61.3873 421.617C57.5044 403.682 53.8064 390.369 47.5197 373.08C46.1329 369.382 44.4688 365.407 41.0482 363.466C39.7538 362.726 38.0897 362.356 36.7954 363.188C35.4087 364.113 35.3162 366.147 35.3162 367.903C35.8709 387.595 38.9218 407.472 40.8633 427.072C40.9557 427.534 40.9557 428.181 40.4935 428.459C39.7538 429.106 38.8293 427.996 38.4595 427.072C33.2823 412.465 31.4333 396.84 27.8277 381.771C26.8107 377.426 24.8693 372.341 20.5241 371.231C19.692 370.954 18.6751 370.954 17.9355 371.416C16.5487 372.156 16.1789 374.097 16.0864 375.669C15.6242 384.637 17.2883 393.512 18.2128 402.387C19.3222 412.28 20.3392 422.172 21.4486 432.064C18.7675 417.919 14.3299 404.236 9.89223 390.554C9.24508 388.427 8.41302 386.209 6.74891 384.822C5.08479 383.343 2.21882 383.065 0.832057 384.822C0 385.931 0 387.503 0 388.89C0.369803 405.253 4.43764 420.878 8.78283 436.502C16.2713 463.312 23.7599 490.216 36.4256 515.085C38.8293 519.8 41.6029 524.7 46.5952 527.196C53.9913 530.894 63.5137 528.213 71.1871 524.145C75.8097 521.741 80.4322 518.69 83.2982 514.53C86.349 510.185 87.2736 504.915 87.9207 499.923C90.1395 481.988 94.0225 475.793 90.6942 458.32Z",
  fill: "#F7A889"
})), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
  d: "M356.987 364.929C368.306 360.861 373.545 346.609 368.689 333.097C363.833 319.585 350.721 311.928 339.402 315.996C328.083 320.064 322.844 334.315 327.7 347.828C332.555 361.34 345.668 368.996 356.987 364.929Z",
  fill: "#F7A889"
})), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
  d: "M341.725 330.16C343.085 329.286 344.45 329.577 345.412 330.78C347.781 333.71 350.224 336.792 352.593 339.722C353.481 340.772 353.083 342.849 351.87 343.638C350.509 344.512 349.145 344.221 348.182 343.018C345.814 340.088 343.37 337.006 341.002 334.076C340.113 333.026 340.622 330.984 341.725 330.16Z",
  fill: "#F76D6D"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask0_240_5",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 671,
  y: 313,
  width: 53,
  height: 59
}, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
  d: "M671 366.1L671.029 324.8M671 366.1C671 369.345 673.621 372 676.889 372H718.111C721.35 372 724 369.345 724 366.1V324.8C724 321.555 721.35 318.9 718.111 318.9H716.167H715.167V317.9V314H714.167M671 366.1L672 366.101L672 366.1C672 368.798 674.178 371 676.889 371H718.111C720.796 371 723 368.794 723 366.1V324.8C723 322.106 720.796 319.9 718.111 319.9H715.167H714.167V318.9V314M671 366.1H672L672.029 324.801V324.8C672.029 322.096 674.184 319.9 676.889 319.9H679.833H680.833V318.9V314H684.722M671.029 324.8L684.722 313V314M671.029 324.8C671.029 321.555 673.621 318.9 676.889 318.9H678.833L671.029 324.8ZM714.167 314V313H710.278V314M714.167 314H710.278M710.278 314H709.278V317.9V318.9H708.278H686.722H685.722V317.9V314H684.722M710.278 314V318.9V319.9H709.278H685.722H684.722V318.9V314M675.889 330.7V331.7H676.889H718.111H719.111V330.7V324.8V323.8H718.111H676.889H675.889V324.8V330.7ZM718.111 367.1H719.111V366.1V336.6V335.6H718.111H676.889H675.889V336.6V366.1V367.1H676.889H718.111ZM687.667 340.55V344.45H683.778V340.55H687.667ZM711.222 340.55V344.45H707.333V340.55H711.222ZM699.444 340.55V344.45H695.556V340.55H699.444Z",
  stroke: "white",
  strokeWidth: 2
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_240_5)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 677,
  y: 338,
  width: 40,
  height: 26,
  fill: "#CFD1DA"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "mask1_240_5",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 671,
  y: 325,
  width: 53,
  height: 59
}, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
  d: "M671 378.1L671.029 336.8M671 378.1C671 381.345 673.621 384 676.889 384H718.111C721.35 384 724 381.345 724 378.1V336.8C724 333.555 721.35 330.9 718.111 330.9H716.167H715.167V329.9V326H714.167M671 378.1L672 378.101L672 378.1C672 380.798 674.178 383 676.889 383H718.111C720.796 383 723 380.794 723 378.1V336.8C723 334.106 720.796 331.9 718.111 331.9H715.167H714.167V330.9V326M671 378.1H672L672.029 336.801V336.8C672.029 334.096 674.184 331.9 676.889 331.9H679.833H680.833V330.9V326H684.722M671.029 336.8L684.722 325V326M671.029 336.8C671.029 333.555 673.621 330.9 676.889 330.9H678.833L671.029 336.8ZM714.167 326V325H710.278V326M714.167 326H710.278M710.278 326H709.278V329.9V330.9H708.278H686.722H685.722V329.9V326H684.722M710.278 326V330.9V331.9H709.278H685.722H684.722V330.9V326M675.889 342.7V343.7H676.889H718.111H719.111V342.7V336.8V335.8H718.111H676.889H675.889V336.8V342.7ZM718.111 379.1H719.111V378.1V348.6V347.6H718.111H676.889H675.889V348.6V378.1V379.1H676.889H718.111ZM687.667 352.55V356.45H683.778V352.55H687.667ZM711.222 352.55V356.45H707.333V352.55H711.222ZM699.444 352.55V356.45H695.556V352.55H699.444Z",
  stroke: "#CFD1DA",
  strokeWidth: 2
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask1_240_5)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 677,
  y: 350,
  width: 40,
  height: 26,
  fill: "#CFD1DA"
}))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M481.763 280.037C464.015 239.757 419.482 216.433 374.767 226.755C324.538 238.428 293.131 288.536 304.436 338.775C305.192 342.032 305.963 346.28 306.813 350.957C309.241 364.334 312.308 381.226 317.5 388.492C319.334 391.173 321.05 393.88 322.648 396.613C324.515 399.929 326.186 403.303 327.909 406.783C333.543 418.164 339.737 430.675 355.228 445.992C357.209 436.328 357.495 410.388 357.71 390.871C357.823 380.585 357.916 372.082 358.228 368.687C359.551 355.173 360.244 317.707 360.244 317.707C361.362 307.725 367.122 306.511 378.462 304.121C392.746 301.11 415.883 296.232 449.752 269.617C455.947 264.656 463.152 271.454 465.797 278.896C466.133 279.827 466.446 280.662 466.742 281.449C468.737 286.759 469.929 289.932 471.469 306.05C475.714 350.695 465.797 397.992 435.5 413.492V435.992L435.5 459.492C470.026 472.008 485.303 475.627 495.361 478.01C508.609 481.148 512.803 482.142 540 498.492C554.296 512.788 563.86 528.147 570.843 542.818C570.287 547.133 569.999 551.533 569.999 556C579.661 626.5 615.666 658 671.999 658C728.332 658 773.999 612.333 773.999 556C773.999 533.681 766.831 513.037 754.671 496.243C753.498 494.554 752.235 492.914 750.882 491.33C741.049 479.351 728.542 469.651 714.271 463.144C712.265 450.388 706.555 438.358 697.314 428.814C685.106 416.161 667.45 407.881 649.982 409.402C650.876 392.285 632.565 380.264 616.252 378.987C611.579 378.627 607.056 378.934 602.583 379.238C596.177 379.674 589.873 380.102 583.369 378.554C578.751 375.988 574.341 373.297 570.129 370.512C570.844 369.478 571.546 368.434 572.233 367.381L565.985 367.699C535.809 346.67 516.147 321 502.072 302.625C493.656 291.638 487.238 283.259 481.763 280.037Z",
  fill: "#243045"
})), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
  d: "M232.834 1041H566.152L555.184 971.807C550.437 942.045 543.591 912.653 534.462 884L505.703 789.999H433.668L433.686 789.513H282.319L270.788 827.88C243.459 895.708 230.568 968.228 232.834 1041Z",
  fill: "#81A94E"
})), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M412.369 1038.89L412.369 876.492L503.001 791L546 916.5L567.273 1038.89L412.369 1038.89Z",
  fill: "url(#paint1_linear_240_5)"
})), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
  d: "M514.674 528.582L521.793 596.718C537 660.994 521.793 695.363 521.793 695.363L505.706 791.605",
  stroke: "#EBECEF",
  strokeWidth: 8,
  strokeMiterlimit: 10
})), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
  d: "M521.792 596.718L509.589 478.751L495.351 474.868L464.103 466.362L440.99 460.076L428.047 456.562H357.877L346.875 459.059L335.319 461.647L302.129 469.043L269.494 476.347V628.429L278 791.604H505.798L521.792 695.27C555.167 661.618 547.401 628.891 521.792 596.718Z",
  fill: "#EBECEF"
})), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M506 791L527.5 628L508.348 526L281.363 611.735L278.5 791L506 791Z",
  fill: "url(#paint2_linear_240_5)"
})), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
  d: "M435.166 458.505V408.859L356.12 367.811C357.229 402.942 360.28 436.779 352.607 457.673L346.875 458.967L367.861 477.827C391.714 499.276 429.618 490.03 440.99 459.984L435.166 458.505Z",
  fill: "#F7A889"
})), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
  d: "M458.464 389.629C449.866 407.194 435.166 419.305 414.18 415.977C400.867 413.851 388.756 407.379 378.401 399.151C363.609 387.41 348.632 372.34 342.253 354.682C336.429 338.596 332.083 322.879 334.025 305.313C335.504 291.723 340.681 275.452 352.423 267.039C365.551 257.701 379.511 250.768 395.69 248.456C412.793 246.053 430.266 248.641 446.168 254.743C463.271 261.307 480.005 272.031 474.18 326.855C471.777 349.135 468.448 369.474 458.464 389.629Z",
  fill: "#F7A889"
})), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
  d: "M435.5 413.994C423.204 420.188 406.23 407.164 387 396.994C403.179 415.484 417 428.494 435.5 428.494V413.994Z",
  fill: "#F7978B"
})), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
  d: "M430.123 365.817C435.599 366.917 441.306 367.882 444.56 368.283C445.987 368.524 446.597 370.168 445.609 371.516C442.877 375.426 436.855 382.034 427.382 380.506C417.908 378.979 414.523 370.035 413.555 364.754C413.286 363.218 414.675 361.788 416.042 362.218C419.46 363.293 424.818 364.771 430.123 365.817Z",
  fill: "white"
})), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
  d: "M481.764 280.036C464.016 239.755 419.483 216.431 374.768 226.753C324.539 238.426 293.132 288.534 304.436 338.774C305.193 342.03 305.964 346.278 306.814 350.956C309.242 364.333 312.309 381.224 317.501 388.491C319.335 391.171 321.051 393.878 322.649 396.611C324.516 399.927 326.187 403.302 327.91 406.782C333.544 418.162 339.738 430.674 355.229 445.991C357.21 436.326 357.496 410.387 357.711 390.87C357.824 380.583 357.917 372.081 358.229 368.685C359.552 355.171 360.245 317.705 360.245 317.705C361.363 307.724 367.123 306.51 378.463 304.119C392.747 301.108 415.884 296.231 449.753 269.616C455.948 264.654 463.152 271.452 465.798 278.894C466.133 279.825 466.447 280.66 466.743 281.448C468.738 286.757 469.93 289.93 471.47 306.048C475.715 350.693 465.798 397.991 435.501 413.491L435.501 459.491C470.027 472.006 485.304 475.626 495.362 478.008C508.61 481.147 512.804 482.141 540.001 498.491C546.062 504.552 551.273 510.805 555.797 517.115C559.548 507.11 563.796 542.582 565.211 531.928C567.265 535.582 546.288 494.894 548 498.491C547.443 502.806 570 551.531 570 555.998C579.5 620 615.667 657.998 672 657.998C728.333 657.998 774 612.332 774 555.998C774 533.68 766.832 513.035 754.672 496.241C753.499 494.552 752.236 492.912 750.883 491.329C741.05 479.349 728.542 469.65 714.272 463.143C712.266 450.387 706.556 438.357 697.315 428.813C685.107 416.16 667.451 407.879 649.983 409.401C650.877 392.284 632.566 380.263 616.253 378.985C611.58 378.625 607.057 378.933 602.584 379.237C596.178 379.672 589.874 380.101 583.37 378.553C578.752 375.986 574.342 373.296 570.13 370.51C570.845 369.476 571.547 368.433 572.234 367.379L565.986 367.697C535.81 346.668 516.148 320.999 502.073 302.623C493.657 291.636 487.239 283.257 481.764 280.036Z",
  fill: "#243045"
})), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
  d: "M434.613 356.628C435.748 356.616 436.819 356.088 437.411 355.114C442.767 347.27 440.213 341.761 438.02 336.892C437.58 335.939 437.14 334.985 436.7 334.032C434.893 329.5 435.224 321.361 435.542 318.63C435.685 316.804 434.38 315.068 432.537 314.922C430.702 314.675 428.944 316.067 428.8 317.893C428.76 318.4 427.583 329.432 430.428 336.496C430.852 337.652 431.386 338.715 431.826 339.668C433.941 344.225 434.994 346.553 431.736 351.297C430.687 352.847 431.142 354.924 432.708 355.967C433.29 356.421 433.897 356.571 434.613 356.628Z",
  fill: "#F76D6D"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 404,
  cy: 336.187,
  rx: 6,
  ry: 8,
  fill: "#243045"
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 452,
  cy: 336.187,
  rx: 6,
  ry: 8,
  fill: "#243045"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_240_5",
  x1: 610.492,
  y1: 999.45,
  x2: 564.185,
  y2: 996.223,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E87D5C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F7A889",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_240_5",
  x1: 393.128,
  y1: 959.58,
  x2: 525.376,
  y2: 808.368,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#618334"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#81A94E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_240_5",
  x1: 458.307,
  y1: 886.178,
  x2: 274.14,
  y2: 658.679,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#384272"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHelloSupervisor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/helloSupervisor.27d0b5ca18d9128938379d5291884aa0.svg";